// ============================================================
// components/LoadingSpinner.jsx — Full-Screen Loading State
// ============================================================

import React from "react";

export default function LoadingSpinner() {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--cream)",
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{
        width: 140, height: 140, borderRadius: "50%", overflow: "hidden",
        marginBottom: "1.5rem", boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      }}>
        <img src="/logo.jpg" alt="Chaitimecrunch" style={{ width: "108%", height: "108%", objectFit: "cover", marginLeft: "-4%", marginTop: "-4%" }} />
      </div>

      <div style={{
        fontFamily: "'Playfair Display', serif",
        fontSize: "2rem",
        fontWeight: 800,
        color: "var(--espresso)",
        marginBottom: "1.5rem",
      }}>
        Chaitime<span style={{ color: "var(--chai)" }}>crunch</span>
      </div>

      {/* Animated dots loader */}
      <div style={{ display: "flex", gap: "0.5rem" }}>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{
            width: 10, height: 10, borderRadius: "50%",
            background: "var(--chai)",
            animation: `pulse 1.4s ease-in-out ${i * 0.2}s infinite`,
          }} />
        ))}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>

      <div style={{
        marginTop: "1rem",
        fontSize: "0.88rem",
        color: "var(--cocoa)",
      }}>
        Loading your bakery experience...
      </div>
    </div>
  );
}